<template>
  <main-large-dialog
    :is-visible.sync="computedIsVisible"
    header-shadow
    :title="title"
    :loading="loading"
    no-paddings-y
    no-paddings-x
    min-body-height="500px"
    dialog-width="60%"
    :agree-text="`dialog.agree${isNew ? 'Add' : 'Save'}`"
    :disagree-text="readOnly ? 'dialog.disagreeClose' : 'dialog.disagree'"
    :has-agree="!readOnly"
    :is-valid="isFormValid"
    @agree="$emit('agree')"
  >
    <template #body>
      <v-row no-gutters class="px-7">
        <template v-if="fetched">
          <v-col cols="6" class="extra-objects-border pt-7">
            <treeview-pattern v-model="computedValue" :treeview="treeview" :read-only="readOnly" />
          </v-col>
          <v-col cols="6" class="pt-5">
            <v-form v-model="isFormValid" ref="form">
              <feature-card-data
                :elements="formSchema"
                v-model="mainElementValues"
                :is-editing-on="!readOnly"
                disable-width-limit
              />
            </v-form>
          </v-col>
        </template>
        <main-loader v-else />
      </v-row>
    </template>
  </main-large-dialog>
</template>
<script>
import { get } from 'vuex-pathify';

import FeatureCardData from '@/components/FeatureCardData';
import MainLargeDialog from '@/components/MainLargeDialog';
import MainLoader from '@/components/MainLoader';
import TreeviewPattern from '@/components/TreeviewPattern';

import prepareAttributesFeatureCardMixin from '@/mixins/prepareAttributesFeatureCardMixin';
export default {
  name: 'TreeviewFeatureDialog',
  components: { FeatureCardData, MainLargeDialog, MainLoader, TreeviewPattern },
  mixins: [prepareAttributesFeatureCardMixin],
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    treeview: {
      type: Object,
      default: () => {
        return {};
      },
    },
    value: {
      type: Object,
    },
  },
  computed: {
    dataSources: get('layers/metadata'),
    layers: get('layers/layers'),

    computedIsVisible: {
      get() {
        return this.isVisible;
      },
      set(nV) {
        this.$emit('update:isVisible', nV);
      },
    },
    computedValue: {
      get() {
        return this.value;
      },
      set(nV) {
        this.$emit('input', nV);
      },
    },
    mainElementValues: {
      get() {
        return this.computedValue?.properties || {};
      },
      set(nV) {
        this.$set(this.computedValue, 'properties', nV);
      },
    },
    isNew() {
      return !this.computedValue?.id;
    },
    title() {
      return this.readOnly
        ? this.$i18n.t(`sidebar.zdmEditor.previewStreet_lamp`)
        : this.$i18n.t(`sidebar.zdmEditor.${this.isNew ? 'add' : 'edit'}Street_lamp`);
    },
  },
  data: () => ({
    fetched: false,

    formSchema: {},
    isFormValid: false,
  }),
  methods: {
    init({ datasource: dataSourceName, layer: layerId } = this.treeview) {
      const datasource = this.dataSources[dataSourceName];
      const layer = this.layers[layerId];
      this.formSchema = this.getForm(layer.form_schema.elements, datasource.attributes_schema.attributes);
      this.fetched = true;
    },
  },
  watch: {
    treeview: {
      handler(nV) {
        if (nV) this.init(nV);
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
<style lang="scss">
.extra-objects-border {
  @include border(right, 1px);
}
</style>
